<template>
    <div class="main-wrapper">
        <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(../../assets/img/auth-bg.jpg);">
            <div class="auth-box">
                <div id="loginform">
                    <div class="logo">
                        <span class="db"><h1>#ZGH</h1></span>
                        <h5 class="font-medium mb-3 db">Connectez-vous 👇</h5>
                    </div>
                    <!-- Form -->
                    <div class="row">
                        <div class="col-12">
                            <!-- <ul v-if="errors.length>0" class="text-center text-danger font-weight-bold list-unstyled">
                                <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
                            </ul> -->
                            <div v-if="errors.length > 0" class="alert alert-danger text-center mt-4">
                                <ul class="list-unstyled mb-0">
                                    <li v-for="(error, index) in errors" :key="index">
                                        <i class="fas fa-exclamation-circle"></i> {{ error }}
                                    </li>
                                </ul>
                            </div>
                            
                            <form class="form-horizontal mt-3" id="loginform" @submit.prevent="loginuser">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="fa fa-user"></i></span>
                                    </div>
                                    <input type="email" v-model="emailzgh" required class="form-control form-control-lg" placeholder="Email" aria-label="Email" aria-describedby="basic-addon1">
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon2"><i class="fa fa-lock"></i></span>
                                    </div>
                                    <input type="password" v-model="passzgh" required class="form-control form-control-lg" placeholder="Mot de passe" aria-label="Password" aria-describedby="basic-addon1">
                                </div>
                                <div class="form-group text-center">
                                    <div class="col-xs-12 pb-3">
                                        <button class="btn btn-block btn-lg" style="background:#00C853; color: #fff;" :disabled="!passzgh || !emailzgh" type="submit">Connecter</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    const base_url=process.env.VUE_APP_API_URL;
    export default {
        name:'LoginView',
        data() {
            return {
            emailzgh: '',
            passzgh: '',
            errors:[]
            }
        },
        created(){

        },
        mounted() {
            // console.log('Width:'+window.innerWidth);
            // console.log('Height:'+window.innerHeight);
            
        // Créer un élément de lien et l'ajouter au head du document
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/css/styles.min.css';
        document.head.appendChild(link);        
    },
    methods:{
        async loginuser() {
            this.errors=[];
                if(this.emailzgh==='' || this.emailzgh.length==0){
                    this.errors.push("Ajouter Email!");
                }
                if(this.passzgh==='' || this.passzgh.length==0){
                    this.errors.push("Ajouter Password!");
                }
                
              if(this.errors.length===0){   
                    axios.post(`${base_url}/auth/login`, {
                        mail: this.emailzgh,
                        password: this.passzgh
                    })
                    .then((user)=>{
                        console.log(user.data);
                        if(user.data.login==false){
                            this.errors.push('Email ou Password Incorrect!')
                        }
                        else if(user.data.resetpwd){
                            // Rediriger l'utilisateur vers la page pour réinitialiser son mot de passe
                            this.$router.push({ name: 'reset-password', params: { id: user.data.user_id } });
                            // this.redirectTo(`/reset-password/${user.data.user_id}`);
                        }
                        else{
                            // console.log(user.data);
                            const dataUser = {
                                id:user.data.utilisateur.id,
                                nom:user.data.utilisateur.nom,
                                prenom:user.data.utilisateur.prenom,
                                telephone:user.data.utilisateur.telephone,
                                mail:user.data.utilisateur.mail,
                                role:user.data.utilisateur.role,
                                code_role:user.data.utilisateur.role_id,
                                token:user.data.token
                            }
                            
                            this.$store.commit('setUser', dataUser);
                            if(user?.data?.token){
                                if(user?.data?.utilisateur?.role_id==3){                                    
                                    this.$router.push('/dossier-declasser');//Pour docteur
                                }
                                else if(user?.data?.utilisateur?.role_id==4){
                                    
                                    this.$router.push('/consultation-preliminaire'); // Pour infirmier
                                }
                                else if(user?.data?.utilisateur?.role_id<3){
                                    
                                    this.$router.push('/dashboard'); //POur admin ou super admin
                                }
                                else if(user?.data?.utilisateur?.role_id==8){
                                    this.$router.push('/payment');
                                }
                                else{
                                    this.$router.push('/profile');
                                }
    
                                setTimeout(function() {
                                    location.reload();
                                },1);
                            }
                        }
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue lors de la connexion');
                        console.error(error);
                            if(error.response) {
                                if (error.response.status === 401) {
                                    this.errors.push('Email ou mot de passe incorrect!');
                                } else {
                                    this.errors.push("Une erreur s'est produite, veuillez réessayer.");
                                }
                            }
                            else {
                                this.errors.push("Impossible de se connecter au serveur.");
                            }                        
                    }) 
                }         
        },
        redirectTo(path) {
            this.$router.push(path);
        }
    }
}
</script>

<style scoped>
*, *::before, *::after {
  box-sizing: border-box;
}

 html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden; /* Empêche le scroll fantôme */
}

.main-wrapper {
  height: 100%;
  width: 100%;
}

.auth-wrapper {
    height: 100dvh; /* <- Solution moderne et dynamique */
  width: 100vw;
  /* background: url('@/assets/auth-bg.jpg') no-repeat center center; */
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}


.fa, .db{color: #00C853;}

.alert-danger ul {
    padding-left: 0;
}

.alert-danger li {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 5px 0;
}
.alert-danger i {
    color: red;
}
.alert-danger {
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>